import { render, staticRenderFns } from "./ClaimStagingClmts.vue?vue&type=template&id=61194010&"
import script from "./ClaimStagingClmts.vue?vue&type=script&lang=js&"
export * from "./ClaimStagingClmts.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStagingClmts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimStagingClmts.vue"
export default component.exports